module.exports = __webpack_public_path__ + "img/Advantage_icon01.9d7c7c58.png";